import React, { PropsWithChildren } from "react";

import { Paper as MuiPaper, PaperProps } from "@mui/material";

import { clsxm } from "@/utils/tailwindMerge";

export const Paper: React.FC<PaperProps & PropsWithChildren> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <MuiPaper
      elevation={0}
      className={clsxm("rounded-lg", className)}
      {...rest}
    >
      {children}
    </MuiPaper>
  );
};
